import React from 'react';

import { UnderConstruction } from 'shared';

function InternalTransfers() {
    return (
        <UnderConstruction
            title="Internal Transfers"
            message="We're giving this page a refresh. Check back after Jalapop is live for 1P internal transfers!"
            actionLabel="Go Home"
            actionLink="/"
        />
    );
}

export { InternalTransfers };
